import React from 'react';
import styles from './progressBar.module.scss';

type Props = {
    progress: {
        id: string;
        progress: number;
    };
    mainStyles?: string;
    additionalStyles?: string;
    subProgressTitle?: string;
    hasInitialStyle?: boolean;
};
const ProgressBar = (props: Props) => {
    const {
        progress,
        additionalStyles,
        mainStyles,
        subProgressTitle = '',
        hasInitialStyle,
    } = props;
    return (
        <>
            {additionalStyles ? (
                <div className={`${additionalStyles}`}></div>
            ) : (
                ''
            )}
            <div className={`${mainStyles}`} key={progress.id}>
                <div className={styles['progress']}>
                    <div
                        className={`${hasInitialStyle ? styles['progress-bar-initial'] : styles['progress-bar']} `}
                        role="progressbar"
                        style={{ width: progress.progress?.toFixed(0) + '%' }}
                    >
                        {progress.progress?.toFixed(0)}% {subProgressTitle}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProgressBar;
